
    <div class="row mt-3" [formGroup]="hyperlinkCustomForm">
        <div class=" {{fromQuickCall ? 'col-xl-2 col-lg-2 col-md-4 col-sm-12 col-12' :'col-md-4 col-lg-4 col-xl-4'}}">
            <label class="label" for="{{ customField.fieldId }}">
                {{ customField.displayName }}:
                <span *ngIf="customField.required" id="mandatory_field">&#42;</span>
            </label>
        </div>
        <div class="{{fromQuickCall ? 'pl-3 col-xl-3 col-lg-3 col-md-7 col-sm-12 col-12'  :'col-md-7 col-lg-6 col-xl-6 col-10'}} sd_custom_input">
            <input class="form-control" formControlName="data" type="url" value={{customField.defaultValue}} [ngClass]="{'error-class':hyperlinkCustomForm.controls['data'].touched && hyperlinkCustomForm.controls['data'].errors?.required}" maxlength="255" autocomplete="off">
            <div *ngIf="hyperlinkCustomForm.controls['data'].touched && hyperlinkCustomForm.controls['data'].errors?.required" class="validation-error-inline text-danger">
                {{ customField.displayName }} {{ 'CustomField.fieldRequired' | translate }}
            </div>
        </div>

        <span *ngIf="customField.dscEnable === 1" [attr.data-toggle]="customField.fieldId" data-trigger="hover" [attr.data-content]="customField.description"
            class="align_description_icon">
            <em class="fa fa-question-circle fa-lg"></em>
        </span>
    </div>
